import { apiFetch } from "./apiClient";

export async function getAllLocations() {
  const res = await apiFetch(`/api/services/service/locations`);
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to get locations",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function getLocationsByCustomerId(customerId) {
  const res = await apiFetch(`/api/services/service/locations/${customerId}`);
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to get locations by customer id",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function getLocationById(locationId) {
  const res = await apiFetch(`/api/services/service/locations/${locationId}`);
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to get location by id",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

// Required customer_name or customer_pk_id, and location_name
export async function upsertLocation(location) {
  console.log(location);
  if (!location.customer_name || !location.customer_pk_id) {
    console.log("Invalid location data:", location);
    return { success: false, error: "Customer name or id required" };
  } else if (!location.location_name) {
    console.log("Invalid location data:", location);
    return { success: false, error: "Location name required" };
  }
  const res = await apiFetch(`/api/services/service/location`, {
    method: "POST",
    body: JSON.stringify(location),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to set locations",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function upsertBuilding(building) {
  if (!building.location_pk_id || !building.building_name) {
    return {
      success: false,
      error: "Location ID and building name are required",
    };
  }
  const res = await apiFetch(`/api/services/service/building`, {
    method: "POST",
    body: JSON.stringify(building),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to set building",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function upsertDepartment(department) {
  if (!department.building_pk_id || !department.department_name) {
    return {
      success: false,
      error: "Building ID and department name are required",
    };
  }
  const res = await apiFetch(`/api/services/service/department`, {
    method: "POST",
    body: JSON.stringify(department),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to set department",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function upsertRoom(room) {
  if (!room.department_pk_id || !room.room_name) {
    return {
      success: false,
      error: "Department ID and room name are required",
    };
  }
  const res = await apiFetch(`/api/services/service/room`, {
    method: "POST",
    body: JSON.stringify(room),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to set room",
    };
  }
  const data = await res.json();
  return { success: true, data };
}
